import { ReactNode } from 'react';

export type ApplianceCareArticleProps = {
  icon: ReactNode;
  description: string;
  additionalDescription?: string;
  key?: number;
};

export const ChooseApplianceCareArticle = ({ icon, description }: ApplianceCareArticleProps) => (
  <article className="flex flex-col items-center gap-space-400 text-center">
    <figure className="text-text-body">{icon}</figure>
    <p className="text-text-body">{description}</p>
  </article>
);
